import { Fragment } from 'react';
import Breadcrumbs from 'shell/components/shared/breadcrumb';
import PersonSearch from 'shell/components/shared/person-search';
import ActionsList from 'mutation/components/registration-citizenship/actions-list';
import { SearchPersonCitizenshipCrumbs } from 'mutation/constants/registration-citizenship-crumbs';

const RegistrationCitizenshipPersonsPage = (): React.ReactElement => {
  return (
    <Fragment>
      <Breadcrumbs items={SearchPersonCitizenshipCrumbs} />
      <PersonSearch
        pathname="/mutazioni/persona/cittadinanza/registrazione"
        action={ActionsList}
        addedTitle={'- Registrazione Cittadinanza'}
      />
    </Fragment>
  );
};

RegistrationCitizenshipPersonsPage.displayName = 'Persons page component';

export default RegistrationCitizenshipPersonsPage;
